import { h } from 'preact'
import style from './index.scss'

const Icon = ({icon, class: mixin}) => <i class={`${style.if} ${style[icon]}` + (mixin ? ` ${mixin}` : '')}></i>

export default Icon



// WEBPACK FOOTER //
// ./components/Icon/index.js